import { observer } from 'mobx-react-lite';
import { IonSlides, IonSlide, IonText, IonButton } from '@ionic/react';

import barwisFileStore from 'stores/barwis-file.store';

import FileSingle from 'pages/file-explorer/components/FileSingle';
import Loader from 'pages/file-explorer/components/Loader';

import { sliderConfig } from 'config.json';
import classes from './style.module.scss';

const FilesExplorer = ({ match, history }) => {
  const barwisFiles = barwisFileStore.getObjects();
  const isLoading = barwisFileStore.getIsLoading();

  return (
    <div className={classes.mainContainer}>
      <div className={classes.title}>
        <IonText className='big'>Recent Files</IonText>
        <IonButton
          onClick={() => history.push('/file-explorer')}
          fill='clear'
          size='small'
        >
          <IonText className='small'>View All</IonText>
        </IonButton>
      </div>
      <div className={classes.content}>
        {!isLoading ? (
          barwisFiles.length > 0 ? (
            <IonSlides options={sliderConfig}>
              {barwisFiles.map((barwisFile, index) => (
                <IonSlide className={classes.ionSlide} key={barwisFile.id}>
                  <FileSingle barwisFile={barwisFile} />
                </IonSlide>
              ))}
            </IonSlides>
          ) : (
            'No Data available'
          )
        ) : (
          <Loader />
        )}
      </div>
    </div>
  );
};

export default observer(FilesExplorer);
